import { useGlobalUI } from '@/state/global-ui'

const GlobalUIWrapper = ({ children }) => {
    const { modal, openModal, closeModal } = useGlobalUI()

    return (
        <>
            {children}

            {/* Global Modal */}
            {modal.isOpen &&
                typeof modal.content === 'function' ? modal.content() : modal.content
            }
        </>
    )
}

export default GlobalUIWrapper
